/** Client-safe brand helpers — no Node/DB imports (frontend-safe). */

export const brandNameIn = (
  brandName: string | null | undefined,
  brands: string[],
): boolean => {
  const brand = brandName?.trim().toLowerCase()
  if (!brand) return false
  return brands.some((name) => name.trim().toLowerCase() === brand)
}

/**
 * GE-family brands for own-brand offer/destination rules.
 * Used by outcome offer steps and host recommendation policy.
 */
export const GE_OWNED_APPLIANCE_BRANDS = [
  "GE",
  "GE Appliances",
  "General Electric",
  "Hotpoint",
  "Cafe",
  "Café",
  "Profile",
  "Monogram",
  "Haier",
]
